<template>

  <div class="main">
    <div class="page-title">FrameFlash分销商管理后台</div>
    <canvas id="canvas-bg" class="canvas-bg"></canvas>

    <div class="login-content">
      <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rules">
        <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" :message="loginErrorInfo" closable
                 :after-close="handleCloseLoginError" />
        <a-form-model-item prop="accountNo">
          <a-input v-model="form.accountNo" size="large" >
            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input-password v-model="form.password" size="large" >
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input-password>
        </a-form-model-item>
        <a-row :gutter="16" v-if="captchaEnabled">
          <a-col class="gutter-row" :span="16">
            <a-form-model-item prop="code">
              <a-input v-model="form.code" size="large" type="text" autocomplete="off" placeholder="验证码">
                <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col class="gutter-row" :span="8">
            <img class="getCaptcha" :src="codeUrl" @click="getCode">
          </a-col>
        </a-row>
        <a-form-model-item prop="rememberMe">
          <a-checkbox :checked="form.rememberMe" @change="rememberMe">记住密码</a-checkbox>
          <router-link style="float: right" class="forgetPwd" :to="{ name: 'forget',params:{code :'fromLogin'} }">分销商注册</router-link>
        </a-form-model-item>
        <a-form-item style="margin-top:24px">
          <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="logining"
                    :disabled="logining" @click="handleSubmit">登录</a-button>
        </a-form-item>
        <div class="user-login-other">
          <!--
            ruoyi后台不支持获取是否开启账户.
            故此处不做隐藏处理. 在ruoyi原前端中是在注册页面定义一个属性手动修改处理.
            <router-link class="register" :to="{ name: 'register' }">注册账户</router-link>
          -->
        </div>
      </a-form-model>
    </div>
  </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'

export default {
  components: {
  },
  data() {
    return {
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        accountNo: 'admin',
        password: 'admin123',
        code: undefined,
        uuid: '',
        rememberMe: false
      },
      rules: {
        accountNo: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      logining: false,
      captchaEnabled: false,
      redirect: undefined,
      canvas: null,
      ctx: null,
      mouse: { x: 0, y: 0 },
      particles: []
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getStorage()
    if (this.captchaEnabled) {
      this.getCode()
    }
  },
  mounted() {
    this.initCanvas()
    this.animate()
  },
  beforeDestroy() {
    if (this.canvas) {
      window.removeEventListener('mousemove', this.handleMouseMove)
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    initCanvas() {
      this.canvas = document.getElementById('canvas-bg')
      this.ctx = this.canvas.getContext('2d')
      this.resizeCanvas()
      this.createParticles()
      window.addEventListener('mousemove', this.handleMouseMove)
      window.addEventListener('resize', this.handleResize)
    },
    resizeCanvas() {
      this.canvas.width = window.innerWidth
      this.canvas.height = window.innerHeight
    },
    createParticles() {
      this.particles = []
      // 手机端减少粒子数量以提升性能
      const isMobile = window.innerWidth <= 768
      const particleCount = isMobile ? 30 : 50
      for (let i = 0; i < particleCount; i++) {
        this.particles.push({
          x: Math.random() * this.canvas.width,
          y: Math.random() * this.canvas.height,
          vx: (Math.random() - 0.5) * 0.5,
          vy: (Math.random() - 0.5) * 0.5,
          size: Math.random() * 2 + 1
        })
      }
    },
    handleMouseMove(e) {
      this.mouse.x = e.clientX
      this.mouse.y = e.clientY
    },
    handleResize() {
      this.resizeCanvas()
      this.createParticles()
    },
    animate() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.ctx.fillStyle = '#1e3a8a'
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)

      // 绘制粒子
      this.particles.forEach(particle => {
        particle.x += particle.vx
        particle.y += particle.vy

        // 边界检测
        if (particle.x < 0 || particle.x > this.canvas.width) particle.vx *= -1
        if (particle.y < 0 || particle.y > this.canvas.height) particle.vy *= -1

        // 鼠标交互
        const dx = this.mouse.x - particle.x
        const dy = this.mouse.y - particle.y
        const distance = Math.sqrt(dx * dx + dy * dy)

        if (distance < 100) {
          const force = (100 - distance) / 100
          particle.vx -= (dx / distance) * force * 0.1
          particle.vy -= (dy / distance) * force * 0.1
        }

        // 绘制粒子
        this.ctx.beginPath()
        this.ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2)
        this.ctx.fillStyle = '#fff'
        this.ctx.fill()

        // 绘制连线
        this.particles.forEach(otherParticle => {
          const dx = particle.x - otherParticle.x
          const dy = particle.y - otherParticle.y
          const distance = Math.sqrt(dx * dx + dy * dy)

          if (distance < 100) {
            this.ctx.beginPath()
            this.ctx.moveTo(particle.x, particle.y)
            this.ctx.lineTo(otherParticle.x, otherParticle.y)
            this.ctx.strokeStyle = `rgba(255, 255, 255, ${0.1 * (1 - distance / 100)})`
            this.ctx.lineWidth = 0.5
            this.ctx.stroke()
          }
        })
      })

      requestAnimationFrame(this.animate)
    },
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.img
          this.form.uuid = res.uuid
        }
      })
    },
    getStorage() {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form = {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe
        }
      }
    },
    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout']),
    handleSubmit() {
      this.logining = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.accountNo)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          this.$store.dispatch('Login', this.form).then((res) => {
            console.log('999', res)
            this.$router.push({ path: this.redirect || '/' }).catch(() => { })
          }).catch((err) => {
            console.log('err', err)
            this.loading = false
            setTimeout(() => {
              this.logining = false
            }, 1000)
            if (this.captchaEnabled) {
              this.getCode()
            }
          })
          // this.Login(this.form)
          //   .then((res) => this.loginSuccess(res))
          //   .catch(err => this.requestFailed(err))
          //   .finally(() => {
          //     this.logining = false
          //   })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: #1e3a8a;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.canvas-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 0;
  touch-action: none; // 防止触摸滚动影响Canvas
}
.page-title {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  color: #fff;
  font-size: 29px;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 0;
  
  @media (max-width: 768px) {
    top: 10%;
    font-size: 20px;
    padding: 0 15px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  @media (max-width: 480px) {
    top: 8%;
    font-size: 18px;
    padding: 0 10px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.login-content {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 15px;
    min-height: 100vh;
    align-items: flex-start;
    padding-top: 25vh;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
    padding-top: 20vh;
    width: 100%;
  }
}
.user-layout-login {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  flex-shrink: 0;

  label {
    font-size: 14px;
    color: #fff;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
    cursor: pointer;
    
    @media (max-width: 768px) {
      height: 44px; // 增加触摸目标大小
    }
  }

  button.login-button {
    padding: 0 20px;
    font-size: 18px;
    height: 48px;
    width: 100%;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #fff;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .register {
      float: right;
    }
  }

  .forgetPwd {
    color: rgba(255, 255, 255, 0.8);
  }

  /deep/ .ant-input {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #fff;
    font-size: 16px;

    &::placeholder {
      color: rgba(255, 255, 255, 0.6);
    }
    
    @media (max-width: 768px) {
      font-size: 16px; // 防止iOS自动缩放
    }
  }

  /deep/ .ant-input-affix-wrapper {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);

    .ant-input {
      background: transparent;
      border: none;
      color: #fff;
    }
    
    @media (max-width: 768px) {
      min-height: 44px; // 增加触摸目标大小
    }
  }

  /deep/ .ant-checkbox-wrapper {
    color: #fff;
  }

  /deep/ .ant-checkbox-inner {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 768px) {
    width: 95%;
    max-width: 100%;
    padding: 25px 20px;
    border-radius: 10px;
    margin: 0 auto;
    
    label {
      font-size: 13px;
    }
    
    button.login-button {
      font-size: 16px;
      height: 44px;
      padding: 0 15px;
    }
  }
  
  @media (max-width: 480px) {
    width: 100%;
    padding: 20px 15px;
    border-radius: 8px;
    margin: 0 auto;
    
    label {
      font-size: 12px;
    }
    
    button.login-button {
      font-size: 15px;
      height: 42px;
    }
    
    .user-login-other {
      margin-top: 16px;
      font-size: 12px;
    }
    
    .forgetPwd {
      font-size: 12px;
    }
  }
}
</style>
